import template from './pdp-freq-bought.html';
export default template;
